import { SECTION_NAME } from 'const/common'
import { partnerFormStaticValidation } from 'modules/Partners/Partners.constants'
import { testProgramValidation } from 'modules/Programs/Program/Test.Programs.constants'
import { onVerifyArray } from 'utils/common'
import * as yup from 'yup'

export enum VALIDATION_TYPE {
	REQUIRED = 'required',
	MIN = 'min',
	MAX = 'max',
	TEST = 'test',
}
export enum FIELD_VALIDATION {
	STARTDATE = 'startDate',
	ENDDATE = 'endDate',
	DESCRIPTION = 'description',
	MAXAGE = 'maxAge',
}
export enum DATA_TYPE {
	STRING = 'string',
	NUMBER = 'number',
	ARRAY = 'array',
	OBJECT = 'object',
}
interface IfieldType {
	globalCodesName?: string
}

export const applyDataTypeInValidation = (dataType: string, fieldType?: IfieldType) => {
	console.log(dataType, 'dataType', fieldType?.globalCodesName)
	switch (dataType) {
		case DATA_TYPE?.STRING:
			switch (fieldType?.globalCodesName) {
				case 'selectDropdown':
				case 'uploadImage':
					return yup.mixed()
				default:
					return yup.string()
			}
		case DATA_TYPE?.NUMBER:
			return yup.number()
		case DATA_TYPE?.ARRAY:
			return yup.array()
		case DATA_TYPE?.OBJECT:
			return yup.object()
		default:
			return yup.mixed()
	}
}
export const applyValidationRule = (
	validationRule: any,
	validationObj: any,
	fieldSlug: string,
	formName: string,
) => {
	const { message } = validationObj

	switch (fieldSlug) {
		case FIELD_VALIDATION?.STARTDATE:
		case FIELD_VALIDATION?.ENDDATE:
			const yupDataType = applyDataTypeInValidation(DATA_TYPE?.STRING)
			return yupDataType?.required(message)
		case FIELD_VALIDATION?.DESCRIPTION:
			if (formName === SECTION_NAME?.ADD_FEE_SCHEDULE) {
				return addFieldValidation(validationRule, validationObj)
			} else {
				return validationRule?.test('greaterThan', message, function (value: any) {
					return (value = value?.length <= 1000 || value?.length === undefined)
				})
			}
		case FIELD_VALIDATION?.MAXAGE:
			return yup
				.number()
				.min(1, 'Age should be greater than 0')
				.max(100, 'Age should be less than or equal to 100')
				.required('This is required field')
				.test(
					'greaterThan',
					'Max age always greater then or equal to min age ',
					function (value: any) {
						return value >= this.parent.minAge
					},
				)
				.nullable()

		default:
			return addFieldValidation(validationRule, validationObj)
	}
}
const addFieldValidation = (validationRule: any, validationObj: any) => {
	const { slug, value, message } = validationObj
	console.log(slug, 'sluf val')
	switch (slug) {
		case VALIDATION_TYPE?.REQUIRED:
			return validationRule?.required?.(message).typeError(message)
		case VALIDATION_TYPE?.MIN:
			return validationRule?.min?.(value, message)
		case VALIDATION_TYPE?.MAX:
			return validationRule?.max?.(value, message)
		// case VALIDATION_TYPE?.TEST:
		// 	return onInsertTestValidation(validationRule, message, fieldSlug)
		default:
			return validationRule
	}
}
export default function commonValidationSchema(formDetails: any, formName = '') {
	const schemaObject: any = {}
	formDetails.forEach((field: any) => {
		// testProgramValidation?.forEach((field: any) => {
		// partnerFormStaticValidation.forEach((field: any) => {
		const { providerFieldValidations, name, dataType, fieldType } = field
		let validationRule = applyDataTypeInValidation(dataType, fieldType)
		if (providerFieldValidations?.length > 0) {
			providerFieldValidations?.forEach((validationobj: any) => {
				const {
					clientFieldValidation: { fieldValidation },
				} = validationobj
				validationRule = applyValidationRule(validationRule, fieldValidation, name, formName)
			})
			schemaObject[name] = validationRule?.nullable()
		} else {
			schemaObject[name] = validationRule?.notRequired()?.nullable()
		}
	})
	console.log(schemaObject, 'schemaObject')
	return yup.object().shape(schemaObject)
}

//  This func is used to get required messages
export const onExtractRequiredMessage = (validationTypeObj: any) => {
	return validationTypeObj?.required?.message
}
//  This func is used to get min messages
export const onExtractMinMessage = (validationTypeObj: any) => {
	return validationTypeObj?.min?.message
}
//  This func is used to get max messages
export const onExtractMaxMessage = (validationTypeObj: any) => {
	return validationTypeObj?.max?.message
}
//  This func is used to get test messages
export const onExtractTestMessage = (validationTypeObj: any) => {
	return validationTypeObj?.test?.message
}
//  Function is used to get all validation type detail in object
export const onExtractValidationDetails = (providerFieldValidations: any) => {
	//
	const validationDetail = onVerifyArray(providerFieldValidations)
		?.map((validationobj: any) => {
			const {
				clientFieldValidation: {
					fieldValidation,
					fieldValidation: { slug },
				},
			} = validationobj
			return {
				[slug?.replace(/ /g, '')?.toLowerCase()]: fieldValidation,
			}
		})
		?.reduce((result: any, currentObject: any) => {
			return { ...result, ...currentObject }
		}, {})
	return validationDetail
}
